// import { JL } from "jsnlog";
// import { isBrowser, isServer } from "@montana/helpers/browser.helper";


// eslint-disable-next-line no-nested-ternary
// const LOGGER_NAME = isBrowser ? "SPA_BROWSER" : (isServer ? "SPA_SERVER" : undefined);

// const logger = JL(LOGGER_NAME);

export function trace(message: string): void {
    console.log(message);
    // logger.trace(message);
}

export function info(message: string): void {
    console.log(message);
    // logger.info(message);
}

export function debug(message: string): void {
    console.log(message);
    // logger.debug(message);
}

export function warn(message: string): void {
    console.log(message);
    // logger.warn(message);
}

export function error(message: string): void {
    console.log(message);
    // logger.error(message);
}

export function exception(message: string, e: Error): void {
    console.log(message, e);
    // logger.fatalException(message, e);
}

// function configureBrowserLogger(): void {
//     /*
//     const ajaxAppender = JL.createAjaxAppender("ajaxAppender");

//     if (ajaxAppender && ajaxAppender.setOptions) {
//         ajaxAppender.setOptions({
//             bufferSize: 20,
//             storeInBufferLevel: JL.getTraceLevel(),
//             level: JL.getWarnLevel(),
//             sendWithBufferLevel: JL.getFatalLevel(),
//         });
//     }
// */
//     const consoleAppender = JL.createConsoleAppender("consoleAppender");

//     if (consoleAppender && consoleAppender.setOptions) {
//         consoleAppender.setOptions({
//             level: JL.getAllLevel(),
//         });
//     }

//     logger.setOptions({
//         appenders: [consoleAppender],
//         level: JL.getAllLevel(),
//     });
// }


// if (isBrowser) {
// configureBrowserLogger();
// }
